import { PHONE_NUMBER } from '@/constants/Common'
import { LocaleEvent } from '../en/event'

const event: LocaleEvent = {
  events: 'Acara',
  eventsNearMe: 'Acara Berhampiran Saya',
  myEvents: 'Acara Saya',
  explore: 'Teroka',
  eventStatus: 'Status Acara',
  addABracket: 'Tambah Kumpulan',
  editEvent: 'Sunting Acara',
  endEvent: 'Tamatkan Acara',
  addAnAnnouncement: 'Tambah Pengumuman',
  submitPayment: 'Hantar Pembayaran',
  register: 'Daftar',
  registrationClosed: 'Pendaftaran Ditutup',
  registered: 'Telah Berdaftar',
  aboutTheEvent: 'Tentang Acara',
  announcements: 'Pengumuman',
  noMoreAnnouncements: 'Tiada pengumuman lagi.',
  eventRegistration: 'Pendaftaran Acara',
  clubMembership: 'Keahlian Kelab',
  clubMembershipQuestion: 'Adakah anda ahli kelab tuan rumah?',
  contactDetails: 'Butiran Hubungan',
  selectYourBrackets: 'Pilih Kumpulan Anda',
  competitionDates: 'Tarikh Pertandingan',
  invitedPlayer: 'Pemain Dijemput',
  invitedPlayerTooltip:
    'Anda telah dijemput oleh pasangan anda untuk acara ini. Untuk menerima atau menolak jemputan ini, sila pergi ke bahagian "bracket saya" di papan pemuka pemain anda.',
  ineligibleBracket: 'Kumpulan Tidak Layak',
  registrationFull: 'Pendaftaran Penuh',
  registerForWaitlist: 'Daftar untuk Senarai Menunggu',
  totalPaymentDue: 'Jumlah Pembayaran Dikenakan (1 Acara)',
  inviteSent: 'Jemputan Dihantar',
  offers: 'Tawaran',
  eventPolicies: 'Polisi Acara',
  iAgreeText: 'Saya telah membaca dan bersetuju dengan',
  healthAndSafetyPolicy: 'Polisi Kesihatan & Keselamatan',
  liabilityPolicy: 'Polisi Tanggungan',
  registeredSuccessfully: 'Anda telah berjaya membayar dan berdaftar.',
  registrationComplete: 'Pendaftaran Lengkap',
  registrationCompleteText:
    'Pendaftaran anda telah lengkap. Anda boleh mengedit butiran pendaftaran anda dari laman utama kumpulan, boleh diakses melalui papan pemuka.',
  continueToPayment: 'Teruskan ke Pembayaran',
  addPhoneNumber: 'Tambah Nombor Telefon',
  editPhoneNumber: 'Sunting Nombor Telefon',
  bracketDetails: 'Butiran Kumpulan',
  players: 'Pemain',
  teams: 'Pasukan',
  matches: 'Perlawanan',
  partnerConfirmed: 'Rakan bergu disahkan',
  noPartnerSelected: 'Tiada rakan bergu dipilih',
  partnerPending: 'Rakan bergu Menunggu',
  viewDraws: 'Lihat Cabutan',
  seedMatches: 'Tanam Perlawanan',
  editBracket: 'Sunting Kumpulan',
  endBracket: 'Tamatkan Kumpulan',
  endBracketModalTitle: 'Adakah anda pasti ingin menamatkan kumpulan ini?',
  endBracketModalDesc:
    'Anda tidak akan dapat membuat perubahan pada kumpulan ini setelah anda memilih untuk menandakannya sebagai tamat.',
  withdraw: 'Tarik Diri',
  editPartner: 'Sunting Rakan Bergu',
  removePartner: 'Buang Rakan Bergu',
  removePartnerFirstDesc: 'Adakah anda pasti ingin menolak',
  removePartnerSendDesc: 'jemputan untuk bermain dalam acara ini?',
  addPartner: 'Tambah Rakan Bergu',
  reopenBracket: 'Buka Kembali Kumpulan',
  reopenBracketDesc:
    'Setelah anda membuka kembali kumpulan ini, anda dapat menambah skor dan mengedit maklumat sehingga tarikh akhir kumpulan.',
  confirmWithdrawFromBracket: 'Adakah anda pasti ingin menarik diri dari kumpulan ini?',
  contactTheEventOrganizer:
    'Jika anda bercadang untuk memohon bayaran balik, hubungi penganjur acara sebelum menarik diri.',
  toRegisterFor: 'Untuk mendaftar bagi',
  answerCompleteThePrecess: 'Jawab butiran berikut untuk menyelesaikan proses. ',
  declineInvite: 'Tolak jemputan',
  declineInviteFirstDesc: 'Adakah anda pasti ingin menolak',
  declineInviteSecondDesc: 'jemputan untuk bermain dalam acara ini?',
  exitTheQueue: 'Keluar dari Barisan',
  exitTheQueueDesc:
    'Keluar dari barisan jika anda telah menjumpai gelanggang untuk perlawanan seterusnya. gelanggang mesti tersedia, dan anda mesti berada secara fizikal di gelanggang setelah anda memilih untuk keluar dari barisan.',
  WL: 'W/L',
  pointDiff: 'Perbezaan Mata',
  waitlisted: 'Dalam Senarai Menunggu',
  switchBracket: 'Tukar Kumpulan',
  switchBrackets: 'Tukar Kumpulan',
  switch: 'Tukar',
  addParticipant: 'Tambah Peserta',
  switchBracketsConfirmation: 'Adakah anda pasti ingin menukar kumpulan untuk pasukan yang dipilih?',
  withdrawPlayer: 'Tarik Diri Pemain',
  confirmWithdrawPlayerFirstText: 'Adakah anda pasti ingin mengeluarkan',
  confirmWithdrawPlayerSecondText: 'dari kumpulan ini?',
  withdrawRefund: 'Tarik Diri/Bayaran Balik',
  addABracketParticipant: 'Tambah Peserta Kumpulan',
  selectAPlayer: 'Pilih pemain dari senarai di bawah.',
  addABracketParticipantDesc:
    'Akaun yang tidak dapat dipilih adalah akaun yang tidak dituntut/dijemput. Pemain yang terlibat mesti mendaftar untuk akaun untuk dapat dipilih.',
  memberOfHostClub: 'Adakah Pemain seorang ahli kelab tuan rumah?',
  selectBracketsToSwitch: 'Pilih kumpulan untuk ditukar',
  confirmTeam: 'Sahkan Pasukan',
  editTeam: 'Sunting Pasukan',
  splitTeam: 'Bahagikan Pasukan',
  replace: 'Ganti',
  addAPartner: 'Tambah Rakan Bergu',
  addAPartnerDesc:
    'Jika rakan anda sudah menjadi pengguna DUPR, anda boleh menambah mereka ke pasukan anda dengan mencari di direktori ini. Jika rakan anda belum mendaftar dengan DUPR, anda boleh menjemput mereka ke pasukan anda melalui e-mel.',
  teamConfirmed: 'Pasukan Disahkan',
  teamPending: 'Pasukan Menunggu',
  showUnclaimedAccountsDesc:
    'Akaun yang tidak dapat dipilih adalah akaun yang tidak dituntut/dijemput. Pemain yang terlibat mesti mendaftar untuk akaun untuk dapat dipilih.',
  replaceTeamDesc:
    'Anda boleh menggantikan pasukan yang berdaftar ini dengan mana-mana pasukan yang dalam senarai menunggu untuk kumpulan ini. Setelah anda membuat pilihan, perlawanan akan diseed semula dalam kumpulan sumber dan sasaran secara automatik. Pilih dari pasukan yang disebutkan di bawah.',
  confirmEditTeam: 'Adakah anda pasti ingin menyunting pasukan ini?',
  confirmThisTeams: 'Adakah anda pasti ingin mengesahkan pasukan ini?',
  createTeam: 'Cipta Pasukan',
  playersDifferentGenders: 'Pemain mesti terdiri dari jantina yang berbeza',
  unmatchedTeams: 'Pasukan Tidak Sepadan',
  pleaseSelectAnyTwoPlayers: 'Sila pilih mana-mana dua pemain dari senarai ini untuk mencipta pasukan',
  youSelectedTwoPlayersSameGender:
    'Anda telah memilih dua pemain dari jantina yang sama. Kerana ini adalah kumpulan campuran, semua pasukan mesti mengandungi seorang lelaki dan seorang perempuan.',
  thisTeamCannotCreated: 'Pasukan ini tidak dapat dicipta kerana',
  and: 'dan',
  isOnTheWaitlist: 'ada dalam senarai menunggu. Sila cipta pasukan dari pemain yang tidak dalam senarai menunggu.',
  afterYouConfirm: 'Setelah anda mengesahkan pilihan ini, pemain ini akan dipindahkan ke tab "pasukan"',
  youLikeToCreateTeam: 'Adakah anda pasti ingin mencipta pasukan ini?',
  forfeit: 'Menyerah Kalah',
  bye: 'Lalu Tanpa Lawan',
  forfeitMatch: 'Perlawanan Menyerah Kalah',
  forfeitMatchDesc:
    'Sila pilih pasukan yang telah menyerah kalah. Pasukan yang anda pilih akan dianggap telah kalah dalam perlawanan.',
  teamA: 'Pasukan A',
  teamB: 'Pasukan B',
  markAsForfeit: 'Tandakan Sebagai Menyerah Kalah',
  youCanAddScores: 'Anda boleh menambah skor antara tarikh ini',
  titleSubmitScoreModal: 'Hantar Skor untuk Semua Permainan',
  scoreWarningMessage:
    'Anda mesti melengkapkan perlawanan dan menghantar skor untuk semua permainan dalam perlawanan anda sekaligus. Jika anda bercadang untuk menghantar skor untuk permainan tambahan dalam perlawanan ini, pergi kembali.',
  editingScoresTitle: 'Menyunting skor perlawanan yang telah selesai',
  editingScoresFirstDesc:
    'Anda sedang menyunting skor perlawanan yang telah selesai. Kedudukan dan perlawanan masa depan bagi acara ini akan tetap tidak terjejas.',
  editingScoresSecondDesc: 'Anda akan kehilangan integriti data dalam Diagram dan kedudukan acara ini.',
  stillContinue: 'Adakah anda masih ingin meneruskan?',
  submitScores: 'Hantar Skor',
  submittingScoresTitle: 'Menghantar skor baru ini akan mempengaruhi perlawanan yang dijadualkan',
  submittingScoresFirstDesc:
    'Anda memilih pemenang baru, beberapa perlawanan pada pusingan seterusnya akan dijadualkan semula.',
  submittingScoresSecondDesc:
    'Jika pemain sudah berada di gelanggang dan anda tidak ingin membuat pengubahsuaian kepada perlawanan semasa, klik Kembali. Anda boleh selalu menyunting skor kepada perlawanan individu selepas acara selesai. Jika anda ingin meneruskan dengan perlawanan baru, Hantar Skor.',
  editScores: 'Sunting Skor',
  addScores: 'Tambah Skor',
  deleteBracketMatchDesc:
    'Jika anda memadam perlawanan ini, anda perlu memulakan semula untuk memasukkan skor dan ia akan mempengaruhi penarafan anda.',
  validateMatch: 'Sahkan Perlawanan',
  validateMatchDesc: `Adakah anda pasti ingin mengesahkan skor ini? Jika ya, perlawanan akan dimuktamadkan dan penarafan pemain akan dikemas kini. Jika skor ini tidak betul, sila hubungi pengarah acara atau hantarkan mesej kepada ${PHONE_NUMBER} dengan skor yang betul.`,
  validate: 'Sahkan',
  substitutes: 'Pengganti',
  selectParticipant: 'Pilih peserta dari senarai di bawah.',
  totalAmountPaid: 'Jumlah Pembayaran',
  showDetail: 'Tunjukkan Butiran',
  playerStatus: 'Status Pemain',
  paymentStatus: 'Status Pembayaran',
  amountPaid: 'Jumlah Dibayar',
  amountRefunded: 'Jumlah Bayaran Balik',
  bracketName: 'Nama Kumpulan',
  pricing: 'Harga',
  pricingDesc:
    'Pemain mesti membayar yuran penyertaan acara ditambah yuran per kumpulan untuk bersaing dalam acara. Harga acara juga mungkin berbeza bergantung kepada sama ada anda merupakan ahli kelab penganjur.',
  eventEntryFee: 'Yuran Masuk Acara',
  bracketPrice: 'Harga Kumpulan',
  importantDates: 'Tarikh Penting',
  importantDatesDesc:
    'Pemain mesti membayar yuran penyertaan acara ditambah yuran per kumpulan untuk bersaing dalam acara. Harga acara juga mungkin berbeza bergantung kepada sama ada anda merupakan ahli kelab penganjur.',
  registrationDates: 'Tarikh Pendaftaran',
  registrationLimit: 'Had Pendaftaran',
  numberTeamsPermitted: 'Jumlah pasukan yang dibenarkan',
  waitlistAllowance: 'Peruntukan Senarai Menunggu',
  allowedWaitlist: 'Pasukan dibenarkan dalam senarai menunggu',
  bracketType: 'Jenis Kumpulan',
  roundRobin: 'Pusingan Robin',
  roundRobinDesc:
    'Turnamen round-robin adalah pertandingan di mana setiap peserta bertemu semua peserta lain secara bergiliran. Round-robin berbeza dengan turnamen eliminasi, di mana peserta akan disingkirkan selepas bilangan kekalahan tertentu.',
  waterfall: 'Air Terjun',
  waterfallDesc:
    'Format turnamen 16 pasukan air terjun memastikan bahawa setiap pasukan bermain tepat 4 perlawanan. Kumpulan dinamakan dengan 8 arah pada kompas (Utara, Selatan, Timur, Barat, Timur Laut, Barat Laut, Tenggara, dan Barat Daya). Untuk setiap perlawanan, setiap pasukan bermain menentang pasukan dengan urutan kemenangan dan kekalahan yang tepat sama.',
  flexLeague: 'Liga Fleksibel',
  flexLeagueDesc:
    'Liga Fleksibel DUPR, serupa dengan pusingan robin, adalah pertandingan di mana setiap peserta bertemu semua peserta lain secara bergiliran. Pemain menyusun perlawanan pada masa lapang mereka, dan acara ini biasanya berlangsung selama tempoh yang lama.',
  numberCourts: 'Jumlah Gelanggang',
  playerGroup: 'Kumpulan Pemain',
  playerRules: 'Peraturan Pemain',
  skillLevel: 'Tahap Kemahiran',
  ageGroup: 'Kumpulan Umur',
  menDoubles: 'Pemain akan bersaing dalam pasukan dua. Setiap pasukan mesti terdiri daripada 2 pemain lelaki.',
  womenDoubles: 'Pemain akan bersaing dalam pasukan dua. Setiap pasukan mesti terdiri daripada 2 pemain perempuan.',
  mixedDoubles:
    'Pemain akan bersaing dalam pasukan dua. Setiap pasukan mesti terdiri daripada seorang perempuan dan seorang lelaki.',
  openDoubles: 'Pemain akan bersaing dalam pasukan dua. Pemain boleh terdiri daripada sebarang kombinasi jantina',
  acceptPartner: 'Terima Rakan Bergu',
  leagueConsentTitle: 'Maklumat Hubungan Anda Akan Dikongsi',
  leagueConsentDesc:
    'Setelah anda mendaftar untuk acara ini, emel dan nombor telefon anda akan dapat dilihat hanya oleh pemain lain yang mendaftar untuk acara tersebut. Ini membolehkan pemain untuk menghubungi satu sama lain untuk penjadualan perlawanan.',
  noQualifyingBrackets: 'Tiada Kumpulan Layak',
  noQualifyingBracketsTitle:
    'Anda tidak layak untuk mana-mana kumpulan terbuka dalam acara ini berdasarkan penarafan DUPR, umur, dan profil jantina anda.',
  pleaseContactEventAdministrator: 'Sila hubungi pentadbir acara di',
  pleaseContactText: 'jika anda percaya ini adalah satu kesilapan.',
  step1: 'Langkah 1: Sila pilih pilihan dan teruskan',
  refundOnly: 'Hanya Bayaran Balik',
  withdrawAndRefund: 'Tarik Diri dan Bayaran Balik',
  step2: 'Langkah 2',
  event: 'acara',
  bracketsOf: 'kumpulan',
  total: 'Jumlah',
  paymentPending: 'Pembayaran Tertunggak',
  freeEvent: 'Acara Percuma',
  fullyRefundedEvent: 'Acara Bayaran Balik Penuh',
  partiallyRefundedEvent: 'Acara Bayaran Balik Sebahagian',
  fullyRefunded: 'Bayaran Balik Penuh',
  splitTeamFirst: 'Bahagikan Pasukan Pertama',
  freeBracket: 'Kumpulan Percuma',
  partiallyRefunded: 'Bayaran Balik Sebahagian',
  viewQualifyingPartners: 'Lihat Rakan Layak',
  viewQualifyingPartnersDesc:
    'Senarai pengguna DUPR ini hanya akan memaparkan rakan berpotensi yang layak untuk kumpulan ini berdasarkan penarafan, umur, dan jantina mereka.',
  joiningWaitlist: 'Anda Sedang Menyertai Senarai Menunggu',
  joiningWaitlistDesc:
    'Anda telah memilih untuk menyertai senarai menunggu bagi sekurang-kurangnya satu kumpulan anda. Anda akan dimaklumkan oleh pentadbiran liga jika anda dipindahkan dari senarai menunggu.',
  fromSelectedBrackets: 'dari kumpulan yang dipilih?',
  sureRefundATotalAmount: 'Adakah anda pasti ingin membayar balik jumlah keseluruhan',
  sureRemove: 'Adakah anda pasti ingin mengeluarkan',
  seedMatchesDesc: 'Tekan Seed Matches untuk Menyemai Pasukan',
  createMatches: 'Cipta Perlawanan',
  seeds: 'Benih',
  reseedMatches: 'Semaikan Semula Perlawanan',
  bracketCreated: 'Kumpulan Dicipta.',
  endEventTitleModal: 'Adakah anda pasti ingin menamatkan acara ini?',
  endEventModalDesc:
    'Anda tidak akan dapat membuat perubahan pada acara ini setelah anda memilih untuk menandakannya sebagai tamat. Acara ini akan ditandakan sebagai tidak aktif secara kekal.',
  moveToUnmatchedTab: `Setelah menarik diri pemain ini, mereka akan dipindahkan ke tab Pemain Tidak Sepadan. Dari sana, anda boleh menambah pemain ini ke pasukan lain atau menariknya daripada acara.`,
}

export default event
